export default "__VITE_ASSET__DBaEUO94__"